import Model from "./Model";
import Assembly from "./Assembly";
import Color from "../utils/Color";
import moment from "moment";

export default class Strategy extends Model {

	constructor(props) {

		super({});

		this.skipFlatParams(['reminder', 'assemblies']);

		this.setDefaultValues({
			id: null,
			name: '',
			description: '<p></p>',
			is_private: false,
			color: '#' + Color.randomHex(),
			icon: '',
			reminder: [],
			assemblies: [],
			start_date: null,
			end_date: null,
		}, props);

		for (let i = 0; i < this.assemblies.length; i++) {
			this.assemblies[i] = new Assembly(this.assemblies[i]);
		}
	}

	isValid(components, datasets) {

		if (!components || !datasets) {
			return false;
		}

		for (let i = 0; i < this.assemblies.length; i++) {
			const assembly = this.assemblies[i];
			const component = components.find(component => component.id === assembly.component);
			const dataset = datasets.find(dataset => dataset.id === assembly.dataset);
			if (!assembly.isValid(component, dataset)) {
				return false;
			}
		}

		return true;
	}

	getIcon() {
		return this.icon || 'mdi-strategy';
	}

	getColor() {
		return this.color || 'primary';
	}

	totalDuration() {
		return this.assemblies.reduce((a, b) => a + b.duration, 0);
	}

	getEvents(start, end) {

		const events = [];

		const slotStart = moment(start);
		const slotEnd = moment(end);

		let startDate = moment(this.start_date);
		let endDate = moment(this.end_date);

		if (!this.start_date) {
			startDate = slotStart;
		}

		if (!this.end_date) {
			endDate = slotEnd;
		}

		if (endDate < slotStart) {
			return [];
		}

		if (slotStart > startDate) {
			startDate = slotStart;
		}

		if (slotEnd < endDate) {
			endDate = moment(slotEnd);
		}

		const daysDiff = endDate.diff(startDate, 'days') + 1;

		for (let i = 0; i < daysDiff; i++) {
			const day = moment(startDate).add(i, 'days');
			const dayOfWeekName = day.locale('en').format('dddd').toLowerCase();
			if (this.reminder.indexOf(dayOfWeekName) !== -1) {
				events.push({
					name: this.name,
					duration: this.totalDuration(),
					startDay: day.format('YYYY-MM-DD'),
					endDay: day.format('YYYY-MM-DD'),
					start: day.format('YYYY-MM-DD'),
					end: day.format('YYYY-MM-DD'),
					color: this.color,
				});
			}
		}

		return events;
	}

	flat(includeNulls = true, includeArray = false) {
		const results = Model.prototype.flat.call(this, includeNulls, includeArray);

		for (let i = 0; i < results.assemblies.length; i++) {
			results.assemblies[i] = results.assemblies[i].flat(false, false);
		}
	}
}
